var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Stratus } from '@stratusjs/runtime/stratus';
import { cookie } from '@stratusjs/core/environment';
import { isJSON, safeUniqueId } from '@stratusjs/core/misc';
import { numeralFormat } from '@stratusjs/angularjs-extras/filters/numeral';
import '@stratusjs/angular';
const min = !cookie('env') ? '.min' : '';
const packageName = 'idx';
const moduleName = 'map';
const componentName = 'map';
const localDir = `${Stratus.BaseUrl}${Stratus.DeploymentPath}@stratusjs/${packageName}/src/${moduleName}/`;
Stratus.Components.IdxMap = {
    bindings: {
        listId: '@',
        googleMapsKey: '@',
        mapType: '@',
        height: '@',
        width: '@',
        fullHeight: '@',
        fullHeightMinusElements: '@',
        referenceParent: '@',
        zoom: '@',
        zoomControl: '@',
        scrollwheel: '@',
        markerClickScroll: '@',
        markerClickHighlight: '@',
        markerPrice: '@',
        markerIcon: '@',
        markerIconHover: '@',
        markerIconLabelOriginX: '@',
        markerIconLabelOriginY: '@',
        template: '@',
    },
    controller($attrs, $scope, Idx) {
        $scope.uid = safeUniqueId(packageName, moduleName, componentName);
        Stratus.Instances[$scope.uid] = $scope;
        $scope.elementId = $attrs.elementId || $scope.uid;
        $scope.instancePath = $scope.elementId;
        $scope.instanceFullPath = `Stratus.Instances.${$scope.instancePath}`;
        this.$onInit = () => {
            $scope.Idx = Idx;
            $scope.listId = $attrs.listId || null;
            $scope.initialized = false;
            $scope.mapInitialized = false;
            $scope.listInitialized = false;
            $scope.googleMapsKey = $attrs.googleMapsKey || null;
            $scope.mapMarkers = [];
            $scope.mapType = $attrs.mapType || 'roadmap';
            $scope.zoom = $attrs.zoom || 18;
            $scope.zoomControl = $attrs.zoomControl || true;
            $scope.scrollwheel = $attrs.scrollwheel || false;
            $scope.height = $attrs.height || null;
            $scope.width = $attrs.width || null;
            $scope.markerClickScroll = $attrs.markerClickScroll && isJSON($attrs.markerClickScroll) ?
                JSON.parse($attrs.markerClickScroll) : false;
            $scope.markerClickHighlight = $attrs.markerClickHighlight && isJSON($attrs.markerClickHighlight) ?
                JSON.parse($attrs.markerClickHighlight) : false;
            $scope.markerPrice = $attrs.markerPrice && isJSON($attrs.markerPrice) ?
                JSON.parse($attrs.markerPrice) : false;
            $scope.markerIcon = $attrs.markerIcon || ($scope.markerPrice ? `${localDir}images/map-marker-black.png` : null);
            $scope.markerIconLabelOriginX = $attrs.markerIconLabelOriginX || ($scope.markerPrice ? 33 : null);
            $scope.markerIconLabelOriginY = $attrs.markerIconLabelOriginX || ($scope.markerPrice ? 13 : null);
            $scope.markerIconHover = $attrs.markerIconHover || null;
            $scope.fullHeight = $attrs.fullHeight || null;
            $scope.fullHeightMinusElements = $attrs.fullHeightMinusElements || null;
            $scope.referenceParent = $attrs.referenceParent || 'document';
            Idx.registerMapInstance($scope.elementId, $scope);
            if ($scope.listId) {
                Idx.devLog($scope.elementId, 'is watching for map to update from', $scope.listId);
                Idx.on($scope.listId, 'init', (source) => {
                    $scope.list = source;
                    $scope.listInitialized = true;
                    prepareMapMarkers(source);
                    $scope.mapUpdate().then();
                });
                Idx.on($scope.listId, 'searched', (source) => {
                    prepareMapMarkers(source);
                    $scope.mapUpdate().then();
                });
            }
            if ($scope.googleMapsKey) {
                $scope.initialized = true;
            }
            else {
                Idx.on('Idx', 'sessionInit', () => {
                    Idx.devLog('map received session init');
                    $scope.initialized = true;
                });
            }
            Idx.emit('init', $scope);
        };
        const prepareMapMarkers = (source) => {
            const markers = [];
            let zIndexCounter = 100;
            source.getPageModels().forEach((model) => {
                if (Object.prototype.hasOwnProperty.call(model, 'Latitude') &&
                    Object.prototype.hasOwnProperty.call(model, 'Longitude')) {
                    const address = Idx.getStreetAddress(model);
                    const marker = {
                        position: { lat: model.Latitude, lng: model.Longitude },
                        title: address,
                        options: {
                            animation: 2
                        },
                        click: {
                            action: 'function',
                            function: () => {
                                if ($scope.list) {
                                    if ($scope.markerClickScroll) {
                                        $scope.list.scrollToModel(model);
                                    }
                                    if ($scope.markerClickHighlight) {
                                        $scope.list.highlightModel(model, 6000);
                                    }
                                }
                            }
                        }
                    };
                    if ($scope.markerPrice &&
                        (Object.prototype.hasOwnProperty.call(model, 'ListPrice') ||
                            Object.prototype.hasOwnProperty.call(model, 'ClosePrice')) &&
                        (model.ClosePrice || model.ListPrice)) {
                        marker.label = {
                            color: 'white',
                            text: numeralFormat(model.ClosePrice || model.ListPrice, 1, '$0[.]0a').toUpperCase()
                        };
                        marker.collisionBehavior = 'REQUIRED_AND_HIDES_OPTIONAL';
                        marker.zIndex = zIndexCounter--;
                    }
                    markers.push(marker);
                }
            });
            $scope.mapMarkers = markers;
        };
        $scope.mapInitialize = (map) => __awaiter(this, void 0, void 0, function* () {
            $scope.map = map;
            $scope.$applyAsync(() => {
                Idx.devLog('Map initialized', $scope.map);
                $scope.mapInitialized = true;
            });
            yield $scope.mapUpdate();
        });
        $scope.mapUpdate = () => __awaiter(this, void 0, void 0, function* () {
            if ($scope.map) {
                $scope.map.removeMarkers();
                yield $scope.mapMarkers.reduce((_unused, marker) => {
                    $scope.map.addMarker(marker);
                }, undefined);
                yield new Promise(r => setTimeout(r, 500));
                $scope.map.fitMarkerBounds();
            }
        });
        $scope.getGoogleMapsKey = () => {
            return $scope.googleMapsKey || Idx.getGoogleMapsKey();
        };
        $scope.on = (emitterName, callback) => Idx.on($scope.elementId, emitterName, callback);
        $scope.remove = () => {
        };
    },
    templateUrl: ($attrs) => `${localDir}${$attrs.template || componentName}.component${min}.html`
};

//# sourceMappingURL=map.component.js.map
